const faqData = {
  DE: {
    title: "FAQ – Häufig gestellte Fragen",
    items: [
      {
        question: "Was ist TeamCoin.de?",
        paragraphs: [
          "TeamCoin.de ist ein innovatives Sportsponsoring- und Kooperationssystem, das Sponsoren, Sportler, Sportvereine und Sportverbände miteinander verbindet.",
          "Ziel ist es, über ein gemeinsames Netzwerk aus Reisen, Sportangeboten und Partnerleistungen nachhaltige Unterstützung für den Vereinssport zu schaffen.",
        ],
      },
      {
        question: "Wie funktioniert die Plattform?",
        paragraphs: [
          "In der aktuellen Phase werden digitale Gutscheine (Tokens) als Teil des Sponsoring-Systems ausgegeben.",
          "Diese berechtigen später zur Nutzung von Vorteilen innerhalb des TeamCoin Ökosystems, sobald die Plattform vollständig aktiviert ist.",
          "Die Tokens sind nicht übertragbar, nicht handelbar und nicht rückerstattbar. Sie dienen ausschließlich der späteren Nutzung innerhalb des Systems.",
        ],
      },
      {
        question: "Wie wird die Sicherheit gewährleistet?",
        paragraphs: [
          "Sicherheit hat höchste Priorität.",
          "Wir arbeiten mit professionellen IT- und Hosting-Partnern zusammen, um Datenschutz, Systemstabilität und sichere Verarbeitung von Daten zu gewährleisten.",
          "Alle Prozesse orientieren sich an den geltenden europäischen Datenschutzrichtlinien.",
        ],
      },
      {
        question: "Welche rechtlichen Aspekte sind zu beachten?",
        paragraphs: [
          "Die ausgegebenen Tokens stellen kein Finanzprodukt, keine Investition und keine Wertanlage dar.",
          "Sie dienen ausschließlich als Zugangselement innerhalb des TeamCoin Sponsoring- und Vorteilsnetzwerks.",
          "Die Nutzung erfolgt im Rahmen der jeweils gültigen rechtlichen und regulatorischen Vorgaben.",
        ],
      },
      {
        question: "Wie kann man Teil von TeamCoin.de werden?",
        paragraphs: [
          "Sponsoren:",
          "Sponsoren unterstützen das Netzwerk durch ihre Teilnahme am System und ermöglichen damit die Förderung des Vereins- und Sportsystems.",
          "Die Unterstützung fließt automatisch in das Netzwerk und stärkt die beteiligten Vereine.",
          "Vereine und Sportler:",
          "Vereine und Sportler können sich einfach über ein Online Formular registrieren und werden anschließend in das Netzwerk aufgenommen.",
        ],
        links: [
          { label: "Hier registrieren: teamcoin.de/clubs", href: "/clubs" },
        ],
        tailParagraphs: [
          "Nach der Registrierung erhalten Sie Zugang zu ihrem Vereinsbereich und weiteren Informationen zur Nutzung des Systems.",
        ],
      },
      {
        question: "Wie werden die Sponsoringmittel verwendet?",
        paragraphs: [
          "Alle Mittel, die über das System entstehen, werden strukturiert eingesetzt, um den Vereinssport nachhaltig zu stärken:",
        ],
        list: [
          "Direkte Unterstützung der Vereine und Sportstrukturen",
          "Bereitstellung von digitalen Nutzungsguthaben im System",
          "Weiterentwicklung und Ausbau des Sport- und Partnernetzwerks",
          "Betrieb und technische Weiterentwicklung der Plattform",
        ],
        tailParagraphs: [
          "Ziel ist ein stabiles, langfristig funktionierendes Sportsponsoring Netzwerk.",
        ],
      },
      {
        question: "Website Entwicklung",
        paragraphs: [
          "Die Plattform wird von Fredy Scharkowski in Zusammenarbeit mit erfahrenen Entwicklern aufgebaut.",
          "Im Fokus stehen Benutzerfreundlichkeit, Sicherheit und Datenschutz.",
          "Die Website wird zudem nach aktuellen EU-Richtlinien zur Barrierefreiheit entwickelt, um allen Nutzern einen einfachen Zugang zu ermöglichen.",
        ],
      },
      {
        question: "Über den Gründer",
        paragraphs: [
          "Ich bin Fredy Scharkowski und arbeite seit 1997 im Bereich Reiseveranstaltung mit Schwerpunkt auf Sportreisen wie Trainingslager, Tennis- und Golfreisen.",
          "Aktuelle Angebote finden Sie unter:",
        ],
        links: [{ label: "teamcoin.de/teamcoin-markt", href: "/teamcoin-markt" }],
        tailParagraphs: [
          "Mit TeamCoin.de entsteht mein bisher größtes Projekt im Bereich Sportsponsoring und digitale Vereinsförderung.",
          "Ab 2027 ist eine strukturelle Weiterentwicklung in Form einer Kapitalgesellschaft geplant, um das System langfristig und regelkonform weiter auszubauen.",
        ],
      },
      {
        question: "Kontakt",
        paragraphs: ["Bei Fragen oder Anregungen erreichen Sie uns jederzeit über"],
        email: "info@teamcoin.de",
      },
      {
        question: "Gemeinsam mehr erreichen",
        paragraphs: [
          "Werde Teil eines Netzwerks, das Vereine stärkt und Sport nachhaltig unterstützt.",
          "© 2025 TeamCoin.de – Sportsponsoring der nächsten Generation",
        ],
      },
    ],
  },
  EN: {
    title: "FAQ – Frequently Asked Questions",
    items: [
      {
        question: "What is TeamCoin.de?",
        paragraphs: [
          "TeamCoin.de is an innovative sports sponsorship and cooperation system that connects sponsors, athletes, sports clubs, and sports associations.",
          "The goal is to create sustainable support for club sports through a shared network of travel offers, sports services, and partner benefits.",
        ],
      },
      {
        question: "How does the platform work?",
        paragraphs: [
          "In the current phase, digital vouchers (tokens) are issued as part of the sponsorship system.",
          "These later enable access to benefits within the TeamCoin ecosystem once the platform is fully activated.",
          "The tokens are non-transferable, non-tradable, and non-refundable. They are intended exclusively for later use within the system.",
        ],
      },
      {
        question: "How is security ensured?",
        paragraphs: [
          "Security has the highest priority.",
          "We work with professional IT and hosting partners to ensure data protection, system stability, and secure data processing.",
          "All processes follow applicable European data protection guidelines.",
        ],
      },
      {
        question: "Which legal aspects must be considered?",
        paragraphs: [
          "The issued tokens are not a financial product, an investment, or a store of value.",
          "They serve solely as an access element within the TeamCoin sponsorship and benefits network.",
          "Use is governed by the currently applicable legal and regulatory requirements.",
        ],
      },
      {
        question: "How can you become part of TeamCoin.de?",
        paragraphs: [
          "Sponsors:",
          "Sponsors support the network through their participation in the system and thereby enable support for clubs and sports structures.",
          "Support flows automatically into the network and strengthens participating clubs.",
          "Clubs and athletes:",
          "Clubs and athletes can easily register via an online form and are then integrated into the network.",
        ],
        links: [
          { label: "Register here: teamcoin.de/clubs", href: "/clubs" },
        ],
        tailParagraphs: [
          "After registration, you receive access to your club area and further information on using the system.",
        ],
      },
      {
        question: "How are sponsorship funds used?",
        paragraphs: [
          "All funds generated through the system are used in a structured way to sustainably strengthen club sports:",
        ],
        list: [
          "Direct support for clubs and sports structures",
          "Provision of digital usage credits within the system",
          "Further development and expansion of the sports and partner network",
          "Operation and technical development of the platform",
        ],
        tailParagraphs: [
          "The goal is a stable, long-term functioning sports sponsorship network.",
        ],
      },
      {
        question: "Website development",
        paragraphs: [
          "The platform is being built by Fredy Scharkowski in collaboration with experienced developers.",
          "The focus is on usability, security, and data protection.",
          "The website is also developed according to current EU accessibility guidelines to ensure easy access for all users.",
        ],
      },
      {
        question: "About the founder",
        paragraphs: [
          "I am Fredy Scharkowski and have worked in the travel industry since 1997, with a focus on sports travel such as training camps, tennis trips, and golf trips.",
          "Current offers can be found at:",
        ],
        links: [{ label: "teamcoin.de/teamcoin-markt", href: "/teamcoin-markt" }],
        tailParagraphs: [
          "With TeamCoin.de, I am building my largest project so far in sports sponsorship and digital club support.",
          "From 2027 onward, a structural development into a corporation is planned to expand the system in a sustainable and compliant way.",
        ],
      },
      {
        question: "Contact",
        paragraphs: ["If you have questions or suggestions, you can reach us anytime at"],
        email: "info@teamcoin.de",
      },
      {
        question: "Achieve more together",
        paragraphs: [
          "Become part of a network that strengthens clubs and supports sports sustainably.",
          "© 2025 TeamCoin.de – Next-generation sports sponsorship",
        ],
      },
    ],
  },
};

export default faqData;
